export default {
  title: 'Dealer Management',
  dealerList: 'Dealer List',
};
